import HeaderOriginal from "../components/HeaderOriginal/HeaderOriginal";
import StickyNavBar from "../components/Navigation/StickyNavBar";
import Footer from "../components/Footer";
import Container from "../components/Container";

const FinancialSustainabilityAndSupportingProjects = () => {
  return (
    <>
      <HeaderOriginal></HeaderOriginal>
      <StickyNavBar></StickyNavBar>
      <Container>
        <div className="py-12 md:py-16 lg:py-24">
          <h1 className="font-bold text-lg md:text-xl lg:text-2xl mb-2 md:mb-4 text-[#21497C] text-center">
            الاستدامة المالية و المشاريع الداعمة
          </h1>
          <div>
            <h2 className="text-[#408099] font-bold text-center mt-6 md:mt-10 mb-4 md:mb-8">
              الاستدامة المالية و المشاريع الداعمة
            </h2>
            <p>
              و لضمان الاستدامة المالية و إنجاز تطلعات الجمعية و مستهدفات خطتها
              الاستراتيجية و التي جاءت لتواكب رؤية المملكة ٢٠٣٠ فقد نفذت عدة
              مشاريع استثمارية.
            </p>
            <h2 className="text-[#408099] font-bold mt-6 md:mt-10 mb-2 md:mb-4">
              الشركة التشيكية السعودية الطبية ( داركوف السعودية ) - التأسيس
              1430هـ
            </h2>
            <p>
              يعنى مشروعها الأول بعلاج أمراض الجهاز العظمي والعضلي وأمراض الجهاز
              العصبي وأمراض جهاز الأوعية الدموية وما ينتج من إصابات بجلطات
              وحالات شلل. و قد بدأ المشروع بطاقة استيعابية أولية بمعدل ( 250 )
              مريضا يوميا.
            </p>
            <h2 className="text-[#408099] font-bold mt-6 md:mt-10 mb-2 md:mb-4">
              شركة خليج البركة - التأسيس 1434هـ ( بشراكة مع نادي الخليج و مجموعة
              مستثمرين محليين)
            </h2>
            <p>
              و قد نفذت الشركة خليج البركة مشروعها الأول المتمثل في مركز الامير
              فيصل بن فهد بحي الخليج. هذا المشروع يتضمن ست صالات أفراح، وصالة
              متعددة الأغراض ، ومساحة كل صالة منها 1000 م مربع ، إلى جانب النادي
              النسائي الجاري تنفيذه حالياً .
            </p>
            <h2 className="text-[#408099] font-bold mt-6 md:mt-10 mb-2 md:mb-4">
              شركة حياة الشرقية التعليمية - التأسيس 1434هـ ( بشراكة مع مجموعة
              مستثمرين محليين)
            </h2>
            <p>
              بهدف تقديم خدمة تعليمية متميزة و الاستفادة من خبرة الجمعية في مجال
              رياض الأطفال ‘ فقد أسست الجمعية شركة تعليمية كما نفذت بناء مشروع
              سواعد الخير و هو عبارة عن مبنى مهيئ للروضة ، وتم افتتاحه 2019هـ
              ليكون مقراً لبيت الطفولة السعيدة. و تهدف الشركة إلى انشاء مشاريع
              تعليمية أخرى مستقبلاً .
            </p>
            <h2 className="text-[#408099] font-bold mt-6 md:mt-10 mb-2 md:mb-4">
              مجمع الكريم السكني التجاري:
            </h2>
            <p>
              و قد وقعت الجمعية عقد بناء مشروع مجمع الكريم السكني التجاري في
              2016 م و هو في مراحل تنفيذه الأخيرة . هذا المشروع الاستثماري و
              الذي أقيم على مساحة (21,000 متر مربع) و بتكلفة إجمالية تقدر بـ
              40,000,000 ريال ، يعود ريعه مباشرة إلى الجمعية و دعماً لبرامجها
              الرعوية و التنموية. و هو عبارة عن مباني سكنية تجارية و يتكون من
              (72) شقة سكنية و (23) محل تجاري و (12) مكتب إداري إلى جانب (140)
              موقف للسيارات .
            </p>
            <p className="mt-6 md:mt-10">
              إلى جانب بعض المشاريع الأخرى كمركز الحاج أحمد الحلال التجاري و
              الاستثمار العقاري و تأجير مجموعة من أراضي الجمعية بعقود طويلة
              الأجل لبناء مشاريع حيوية تعود بالنفع على المدينة كما يعود ريعها
              أيضاً على برامج و نشاطات الجمعية.
            </p>
          </div>
        </div>
      </Container>
      <Footer></Footer>
    </>
  );
};

export default FinancialSustainabilityAndSupportingProjects;
